import React, { useLayoutEffect, useRef } from 'react';
import cx from 'classnames';

import { TickIcon } from '@mc/wink-icons';
import scrollIntoView from 'scroll-into-view-if-needed';
import stylesheet from './Option.less';

export type OptionProps = {
  children?: $TSFixMe;
  disabled?: boolean;
  id?: string;
  isFiltered?: boolean;
  isHighlighted?: boolean;
  isSelected?: boolean;
  onClick?: $TSFixMeFunction;
  onHighlight?: $TSFixMeFunction;
  value?: $TSFixMe;
};

function Option({
  value,
  children,
  disabled = false,
  id,
  isFiltered = false,
  isSelected,
  isHighlighted = false,
  onClick,
  onHighlight,
}: OptionProps) {
  const ref = useRef();
  useLayoutEffect(() => {
    if (isHighlighted && ref.current) {
      scrollIntoView(ref.current, {
        block: 'nearest',
        scrollMode: 'if-needed',
        boundary: (ref.current as $TSFixMe).parentNode,
      });
    }
  }, [isHighlighted]);

  if (isFiltered) {
    return null;
  }

  return (
    <div
      // @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
      ref={ref}
      aria-disabled={disabled || undefined}
      aria-selected={isSelected}
      role="option"
      id={id}
      className={cx(stylesheet.option, {
        [stylesheet.isHighlighted]: isHighlighted,
      })}
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onClick={() => !disabled && onClick()}
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onMouseMove={() => !disabled && onHighlight(value)}
    >
      {children || value}
      {/* Always render the tick mark to include it in width calculations for
+      listboxes inside popups (in particular, SelectInline's). We adjust the
+      CSS `visibility`. Note that the tick mark is purely visual and not exposed
+      to assistive technology; the `aria-selected` state is. */}
      <TickIcon className={stylesheet.selectedIcon} />
    </div>
  );
}

export default Option;
